import { isMobile } from "@/utils/util";
import './index.scss';
import { LayoutDesktop } from "../LayoutPC/LayoutDesktop";

// 加载中组件
export function LoadingPage() {
  return (
    isMobile() ? <div className="loading"></div> : <div className="pc-loading"></div>
  );
}




export function DefaultLoadingPage() {
  return (
    <>
      {
        isMobile() ? <div className="default-loading-page"></div> : (
          <LayoutDesktop>
            <div className="pc-default-loading-page-placeholder"></div>
          </LayoutDesktop>
        )
      }
    </>

  );
}
